export class CheckinCheckoutHelper {
    // Identity comparison for SharePoint checkout-user records. Case-insensitive:
    // AAD UPNs/emails are case-insensitive identifiers. Deliberately permissive when
    // the record carries no resolvable identity at all (system/app-only checkouts).
    static compareCurrentUser = (checkedOutUser: any, currentUsername: string): boolean => {
        try {
            // || (not ??) so an empty-string email falls through to sip: SharePoint's
            // RenderListDataAsStream emits blank user-field properties as "".
            const identity: string = (checkedOutUser?.email?.trim() || checkedOutUser?.sip?.trim() || "").toLowerCase();
            return !identity || identity === currentUsername?.trim()?.toLowerCase();
        } catch (error) {
            // console, not utilities/logger: logger pulls in the ApiService/AuthModule
            // chain, which this dependency-free helper must not drag into its importers.
            console.error("CheckinCheckoutHelper.compareCurrentUser", error);
            return true;
        }
    };
}
